import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgWorried: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 335.62 435.65" {...props}>
    <path
      d="M279.6 161.84c-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-25.71-12.35-31.17-7.98a128.52 128.52 0 0 0-75.39-24.29 128.5 128.5 0 0 0-75.92 24.68c-4.12-4.09-20.31-17.14-30.8 1.84 0 0-10.09 18.79-8.5 44.3a128.57 128.57 0 0 0-13.9 58.3c0 71.3 53.94 123.94 129.25 122.41 80.2-1.63 128.98-51.11 128.98-122.42 0-24.07-6.6-46.6-18.07-65.9z"
      fill="#ff841f"
    />
    <path
      d="M297.67 227.74c0-24.07-6.6-46.6-18.07-65.9-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-25.71-12.35-31.17-7.98a128.52 128.52 0 0 0-75.39-24.3 128.5 128.5 0 0 0-75.92 24.69c-4.12-4.09-20.31-17.14-30.8 1.84 0 0-10.09 18.78-8.5 44.3a128.57 128.57 0 0 0-13.9 58.3s84.58 26.4 258.23 0z"
      fill="#d66f29"
    />
    <path
      d="M239.15 424.55c0-6.87-31.9-13.24-71.27-13.24s-71.28 5.27-71.28 12.14c0 6.88 31.91 9.65 71.28 9.65s71.27-1.68 71.27-8.55z"
      opacity={0.28}
    />
    <circle cx={215.97} cy={207.25} r={40.29} opacity={0.1} />
    <circle cx={215.97} cy={212.58} r={40.29} fill="#fff" />
    <circle cx={115.76} cy={207.39} r={40.62} opacity={0.1} />
    <circle cx={115.76} cy={212.76} r={40.62} fill="#fff" />
    <circle cx={209.57} cy={215.38} r={11.46} fill="#191919" />
    <circle cx={122.51} cy={215.38} r={11.46} fill="#191919" />
    <path
      d="M39.65 228.5s-1.46-16.93 13.15-40.62c0 0 12.62-21.29 18.85-9.4 0 0 16-2.16 9 19.63 0 0 7.6 4.1-3.54 18.03 0 0-19.96 28.13-37.46 12.36zm257.15 4.25s6.36-7.8-12.57-43.14c0 0-10.13-22.68-17.61-11.73 0 0-15.6-4.22-11.1 18.23 0 0-9.18 2.18.3 17.39 0 0 21.9 32.57 40.98 19.25z"
      fill="#ff841f"
    />
    <path
      d="M83.52 136.22c-3.33 5.42-6.54 10-5.42 16.07a9.47 9.47 0 0 0 1.52 3.98c.85 1.15 2.25 1.99 3.67 1.83 2.25-.24 3.55-2.61 4.3-4.74 1.94-5.49-2.19-11.82-3.9-17.14m19.08-8.25c-1.69 5.65-5.1 13.74-3.1 18.79a8.34 8.34 0 0 0 1.97 3.18c.94.85 2.28 1.34 3.49.96 1.9-.58 2.62-2.85 2.91-4.82.75-5.06-2-14.8-5-18.52"
      fill="#fff"
    />
    <g fill="#fff">
      <path d="M187.16 269.56c-1.7-1.6-10.4-8.58-16.55-13.2-2.96-2.21-5.87-1.08-6.43-.61-10.8 9.14-20.52 15.2-21.07 15.06-.42-.12-.87-.8.41-2.98 5.27-9 7.68-17.91 11.84-23.55 7.83-10.59 13.97-8.2 18.52-3 1.72 1.95 19.16 27.66 16.91 29.35 0 0-1.86.6-3.63-1.07z" />
      <path d="M169.16 286.46c-5.55 1.8-8.47-1.26-10.92-2.94-6.56-4.51-16.44-12.6-15.22-12.99 2.26-2.03 9.23.26 13.8 2.31 2.65 1.2 8.16 5.33 12.43 3.29 2.47-1.19 5.5-2.17 8.08-3.18 4.91-1.92 10.77-3.02 13.29-2.58 1.93 1.7-18.38 15.1-21.46 16.1z" />
    </g>
    <path
      d="M188.83 23.68c0 1.59-.06 3.27-.5 4.9a22.19 22.19 0 0 1-1.83 4.6c-.79 1.5-1.94 2.9-3.05 4.22-1.12 1.32-4.16 2.86-6.2 3.52l-.39 9.76-13.84.12.8-16.06c7-3.82 8.67-7.35 8.67-10.3 0-1.23-.38-2.6-1.2-3.42-.83-.82-2.33-1.41-4.24-1.36-1.7.04-3.25.78-4.48 2.01a10.16 10.16 0 0 0-2.72 4.69l-12.98-2.56c1.64-13.4 9.29-20.23 23.17-20.23 2.64 0 5.11.57 7.4 1.72a19.69 19.69 0 0 1 5.96 4.54c1.68 1.88 3 4.03 3.97 6.44a19.69 19.69 0 0 1 1.46 7.41zm-12.2 40.21c0 .96-.19 1.86-.57 2.72a7.44 7.44 0 0 1-3.8 3.8c-.86.38-1.76.57-2.72.57-2 0-3.69-.68-5.05-2.04a6.86 6.86 0 0 1-2.04-5.05c0-2 .68-3.7 2.04-5.05a6.86 6.86 0 0 1 5.05-2.04c.96 0 1.86.19 2.72.57a7.42 7.42 0 0 1 3.8 3.8c.38.86.57 1.77.57 2.72z"
      fill="#404040"
    />
  </svg>
);
/* eslint-enable max-len */

export default SvgWorried;
